import { actionHelpers } from 'app-components/flux/core';

export const makeAiPromptRequestAction = actionHelpers.createAction('MAKE_AI_PROMPT_REQUEST', (payload) => payload);

export const makeClearAiConversationAction = actionHelpers.createAction('CLEAR_AI_CONVERSATION');
export const makeAiPromptRequestSuccess = actionHelpers.createAction('MAKE_AI_PROMPT_REQUEST_SUCCESS');
export const makeAiPromptRequestFailure = actionHelpers.createAction('MAKE_AI_PROMPT_REQUEST_FAILURE');
